<script>
  import { imgSrc, Link } from '$client';
  export let data;
</script>

<section class="container">
  <div>
    <h2 class="h2">{data.header}</h2>
    <p>{data.description}</p>
    <div class="partner-links">
      {#each data.links as { href, background, img }}
        <Link attributes={{ style: `background: ${background};` }} {href}>
          <img
            loading="lazy"
            height={img.data.attributes.height}
            width={img.data.attributes.width}
            src={imgSrc(img.data.attributes.url)}
            alt={img.data.attributes.alternativeText} />
        </Link>
      {/each}
    </div>
  </div>
  <img
    loading="lazy"
    height={data.img.data.attributes.height}
    width={data.img.data.attributes.width}
    src={imgSrc(data.img.data.attributes.url)}
    alt={data.img.data.attributes.alternativeText} />
</section>

<style lang="scss">
  section {
    display: inline-flex;
    gap: 20px;
    justify-content: center;
    padding-block: 50px;

    @media only screen and (max-width: 1499.98px) {
      padding-block: 40px;
    }

    @media only screen and (max-width: 767.98px) {
      padding-block: 30px;
    }

    @media only screen and (max-width: 991.98px) {
      flex-direction: column;
      align-items: center;
    }

    > div {
      display: flex;
      flex-direction: column;
      gap: 40px;
      align-items: flex-start;
      justify-content: flex-start;
    }
  }

  .partner-links {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 20px;
    width: 100%;
    max-width: 500px;

    @media only screen and (max-width: 991.98px) {
      align-items: center;
      justify-content: center;
      max-width: 100%;
    }

    :global(a),
    :global(div) {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: max(calc(50% - 20px), 200px);
      padding: 15px 20px;
      border-radius: 10px;
    }

    img {
      max-width: 160px;
      filter: grayscale(1);
    }
  }

  img {
    height: 100%;

    @media only screen and (max-width: 1199.98px) {
      max-width: 400px;
    }

    @media only screen and (max-width: 575.98px) {
      max-width: 300px;
    }
  }

  h2 {
    color: #13c890;
    font-weight: 800;
    font-family: Vela Sans;
  }

  p {
    font-weight: normal;
    font-size: 20px;
    font-family: Roboto;
    line-height: 26px;

    @media only screen and (max-width: 575.98px) {
      font-size: 14px;
      line-height: 20px;
    }
  }
</style>
